import React, { useState, useEffect, useContext } from "react";
import {
  Text,
  Box,
  Button,
  Flex,
  Center,
  Link,
  useMediaQuery,
  useDisclosure,
} from "@chakra-ui/react";
import { useSession } from "next-auth/react";
import { ContactListDropdown } from "components/contact-list-dropdown";
import { getAccount, getAuthUrl, updateUser } from "utils/sessionHelper";
import { useFirebaseUser } from "utils/useFirebaseUser";
import TweetsReplies from "../tweets/tweetsReplies";
import PuffLoader from "react-spinners/PuffLoader";
import { MainContext } from "context/mainContext";
import { useOnboardingSteps } from "components/onboard-panel/useOnboardingSteps";
import { getContacts } from "controllers/list";
import { confirmApiBridgeLoad } from "utils/useApi";
import { ConfirmPopup } from "components/popups/confirmPopup";
import { RateLimiter } from "limiter";
import toast from "react-hot-toast";
import { grow } from "../../controllers/search";
import { textStyle } from "theme/names";
import { useInterval } from "../../utils/useInterval";
import { FilterSortRefreshAutoLike } from "./filter-sort-refresh-autolike-panel";
import { ENGAGE_FILTER_KEY } from "./utils";
import { getCachedKey, updateCachedKey } from "utils/localforageHelpers";

let limit = 2;
const limiter = new RateLimiter({ tokensPerInterval: limit, interval: "day" });

const defaultFiltersValues = {
  defaultMinFollowers: 0,
  defaultMaxFollowers: 999999999,
};

export function PeoplePanel() {
  const [hasFetched, setHasFetched] = useState<boolean>(false);
  const [isSending, setIsSending] = useState<boolean>(false);
  const [data, setDataInternal] = useState<any>(null);
  const [selectedList, setSelectedList] = useState<any>(null);
  const { data: session } = useSession() ?? {}
  const isAuthenticated = useFirebaseUser();
  const [isTooSmall] = useMediaQuery("(max-width: 800px)");
  const mainContext: any = useContext(MainContext);
  const { updateOnboardSteps } = useOnboardingSteps();
  const isValidToken = getAccount(session)?.thWriteAccessToken;
  const [refresh, refresher] = useState({});
  const [noEngage, setNoEngage] = useState<boolean>(false);
  const [isApiBridgeLoaded, setIsApiBridgeLoaded] = useState<boolean>(confirmApiBridgeLoad());
  const [countPeopleInList, setCountPeopleInList] = useState<number>(0);

  const { defaultMinFollowers, defaultMaxFollowers } = defaultFiltersValues;
  const [nbMinDaysOld, setNbMinDaysOld] = React.useState(0);
  const [nbMaxDaysOld, setNbMaxDaysOld] = React.useState(2);
  const [nbMinLikes, setNbMinLikes] = React.useState(40);
  const [nbMinRt, setNbMinRt] = React.useState(0);
  const [nbMinFollowers, setNbMinFollowers] = React.useState(defaultMinFollowers);
  const [nbMaxFollowers, setNbMaxFollowers] = React.useState(defaultMaxFollowers);
  const [percent, setPercent] = React.useState(0);
  const [filters, setFilters] = useState<any>(defaultFiltersValues);
  const { isOpen: isOpenConfirmRequest, onOpen: onOpenConfirmRequest, onClose: onCloseConfirmRequest } = useDisclosure();


  useEffect(() => {
    if (session && isAuthenticated && !hasFetched && isValidToken) {
      setHasFetched(true);
      const savedFilters = localStorage.getItem(ENGAGE_FILTER_KEY);
      if (savedFilters) {
        const filtersJSON = JSON.parse(savedFilters);
        const { minFollowers, maxFollowers, minDaysOld, maxDaysOld } = filtersJSON;
        setNbMinDaysOld(minDaysOld || nbMinDaysOld);
        setNbMaxDaysOld(maxDaysOld || nbMaxDaysOld);
        setNbMinFollowers(minFollowers);
        setNbMaxFollowers(maxFollowers);
        setFilters(filtersJSON);
      }

      setNoEngage(getAccount(session)?.noEngage);
    }
  }, [session, isAuthenticated]);

  useInterval(() => {
    if (percent < 95) {
      let inc = Math.round(Math.random() * 4);
      setPercent(percent + inc);
    }
  }, 900);

  useEffect(() => {
    setPercent(0)
  },
    [selectedList])

  const setData = (tweets) => {

    console.log('setData tweets:', tweets)

    setDataInternal(tweets);
  }

  const sendRequest = async () => {

    if (!getAccount(session)?.idParent) {
      toast.error("Please connect your LinkedIn account to use this feature");
      return;
    }

    const peopleInList = await getContacts(getAccount(session)?.id, selectedList?.id, 100);

    if (!peopleInList?.length) {
      toast.error("Your list is empty, please add contacts before using this feature");
      return;
    }

    if (isSending) return;
    setIsSending(true);
    setPercent(0);

    setCountPeopleInList(peopleInList?.length ?? 0);

    let getFilters: any = localStorage.getItem(ENGAGE_FILTER_KEY);

    if (getFilters) getFilters = JSON.parse(getFilters);

    let params = {
      isPersonalizedSorting: false,
      nbMinDaysOld: getFilters?.minDaysOld || nbMinDaysOld,
      nbMaxDaysOld: getFilters?.maxDaysOld || nbMaxDaysOld,
      nbMinLikes: nbMinLikes,
      nbMinRt: nbMinRt,
      nbMinFollowers: getFilters?.minFollowers || defaultMinFollowers,
      nbMaxFollowers: getFilters?.maxFollowers || defaultMaxFollowers,
      count: 50,
      mode: "people",
      noHashtags: getFilters?.noHashtags || false,
      notLiked: getFilters?.notLiked || false,
      noMediaAndLinks: getFilters?.noMediaAndLinks || false,
      positiveKeywords: getFilters?.positiveKeywords || [],
      negativeKeywords: getFilters?.negativeKeywords || [],
      engageAccounts: peopleInList.map((contact) => contact.username).slice(0, 100).join(","),
    };

    let data = await grow(session, params, mainContext.onOpenUpgrade);
    setIsSending(false);

    if (data?.success && data?.tweets?.length) {
      // const repliedTweets = await getCachedKey("allRepliedTweets");
      // console.log(repliedTweets, 'repliedTweets');
      // const filteredTweets = data?.tweets?.filter((tweet) => !repliedTweets.tweets.includes(tweet.id_str)) ?? data?.tweets;
      // data.tweets = [...filteredTweets];
      setData(data);
    }
    else {
      toast.error("No LinkedIn posts found. Please check your filters and try again.");
      setData({ success: false });
    }
    // else {
    //   console.log("loading API bridge");
    //   setData(null);
    //   setIsApiBridgeLoaded(confirmApiBridgeLoad());
    //   //check if apibridge is loaded...
    //   if(!isApiBridgeLoaded) {
    //     setDataInternal(null);
    //     setIsSending(false);
    //     return;
    //   }
    //   const peopleInList = await getContacts(getAccount(session)?.id, selectedList?.id);
    //   setCountPeopleInList(peopleInList.length);
    //   await fetchContactInListPostFromAPI(session, peopleInList, setData, setIsSending, 10);
    // }
    updateOnboardSteps("engage");
  };

  const onSort = (sortedData) => {
    if (sortedData?.length) {
      const finalSortedData = {
        ...data,
        tweets: [...sortedData],
      };

      setData(finalSortedData);
    }
  }

  const onFilter = async (filterData) => {
    setFilters(filterData);
    onRefresh([]);
  }

  const onRefresh = async (sortedFilteredData) => {
    setData(null); //reset data on refresh;
    sendRequest && sendRequest();
  }

  return (
    <Box maxW="800px" margin="auto">
      {/* <Center my={5}>
        <Tag colorScheme="red" >Due to exceptional demand, we're experiencing difficulties with this feature - the team is working on it</Tag>
      </Center> */}
      <Flex alignContent="center" justifyContent="center" mb={3}>
        <Text
          textStyle={textStyle["body.medium.light"]}
          // color={theme.colors.gray[500]}
          fontSize="md"
        >
          Select a list of people you’ve created using the
          <Link
            ml={1}
            mr={1}
            textStyle={textStyle["body.medium.primary"]}

            // color={theme.colors.gray[500]}
            // fontSize="md"
            textDecoration="underline"
            href="/contacts"
          >
            Taplio CRM
          </Link>
          feature.
        </Text>
      </Flex>
      <Box>
        <Flex
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
          mt="6"
        >
          <Box ml="-2">
            <ContactListDropdown
              placeholder="Pick from a contact list"
              onSelectList={(list) => {
                setSelectedList(list);
              }}
              reset={!selectedList}
              isDisabled={isSending}
            />
          </Box>
          <Button
            ml={5}
            variant="primary"
            // colorScheme="blue"
            // bg="blue.700"
            // color="white"
            // _hover={{ bg: "blue.600" }}
            isDisabled={!selectedList?.name}
            onClick={() => {
              if (selectedList && selectedList.name) {
                // if (!limiter.tryRemoveTokens(1)) {
                //   onOpenConfirmRequest();
                // }
                // else {
                //   sendRequest();
                // }
                sendRequest();
              }
            }}
            isLoading={isSending}
          >
            Go
          </Button>
        </Flex>
        <Box>

          {
            isSending && (
              <Center pt={10}>
                <Flex flexDirection="column" alignItems="center">
                  <PuffLoader color={"#0A66C2"} loading={isSending} cssOverride={{ display: "block", margin: "0 auto", borderColor: "red" }} size={50} />
                  <Text textStyle={textStyle['body.bold.standard']} py="2">{`${percent}%`}</Text>
                  <Text textStyle={textStyle['body.bold.standard']} pb="2">This process can take a minute or two.</Text>
                  {/* <Text textStyle={textStyle['body.bold.standard']}>Feel free to navigate to other pages while we fetch these posts ..</Text> */}
                </Flex>
              </Center>
            )
          }

          {

            !isSending && isValidToken && (
              <Flex flexDirection="column">
                <FilterSortRefreshAutoLike
                  session={session}
                  isAuthenticated={isAuthenticated}
                  data={data?.tweets}
                  mode={"people"}
                  onSortCallback={onSort}
                  onFilterCallback={onFilter}
                  isLoadingPosts={isSending || !selectedList?.name}
                  onRefreshButtonClickCallBack={onRefresh}
                  filters={filters}
                />
                {
                  //@ts-ignore
                  data?.tweets?.length ? (
                    <Center pt={6} flexDirection="column">
                      {
                        countPeopleInList >= 25 &&
                        <Text textStyle={textStyle["body.medium.light"]}
                        // fontWeight="300"
                        >Displaying posts from 25 people, randomly selected form the list</Text>
                      }
                      <TweetsReplies data={data} setData={setDataInternal} refresher={refresher} linkedinPostProps={{ showNumComments: true, disableFollowersCount: false, disableIntro: false, disableUserPopup: false, }} />
                    </Center>
                  ) : null}
                {
                  data && !data?.tweets?.length && (
                    <Center pt={10}>
                      <Flex flexDirection="column" alignItems="center">
                        <Text textStyle={textStyle['body.bold.standard']} pb="3">
                          Unfortunately we were unable to find any posts from these accounts.
                        </Text>
                        <Text textStyle={textStyle['body.bold.standard']}>
                          Feel free to <Text as="ins">try again</Text>, <Text as="ins">change the filter settings</Text> or contact our support for help.
                        </Text>
                      </Flex>
                    </Center>
                  )
                }
              </Flex>
            )
          }
        </Box>
        {/* {
          !isApiBridgeLoaded && !isMobile && <ConfirmPopup 
            isOpen={!isApiBridgeLoaded}
            onClose={() => {window.location.reload();}}
            title="Oops! We couldn’t detect the Taplio Chrome Extension."
            body={[
              <>We can't seem to find the Taplio Chrome Extension on your browser.</>,
              <>Please install the Taplio Extension if you haven't.</>,
              <>Unfortunately, you need it to be able to use the engage feature of Taplio.</>,
              <>But don't worry! <Link isExternal href='https://chrome.google.com/webstore/detail/influent-leaders-stats/dfpbcakpogbfaohnnjlgghdjkgaoiaik'><a style={{textDecoration:"underline"}}>You can easily install it here for free.</a></Link></>,
              <>(just make sure you’re on Google Chrome).</>,
              <>Are you positive you already have the Chrome extension installed?</>,
              <>If so, please <Link isExternal href='https://linkedin.com'><a style={{textDecoration:"underline"}}>open &amp; sign into LinkedIn.com in another Chrome tab, refresh the LinkedIn tab</a></Link> and come back here to refresh the page or click Confirm.</>
            ]}
            callback={() => {}}
          />
        } */}
      </Box>
      <ConfirmPopup isOpen={isOpenConfirmRequest} onClose={onCloseConfirmRequest}
        title="⚠️ Warning - don't abuse this feature"
        // body={"Using this feature too much makes your account at risk as Linkedin doesn't allow checking too much profiles in a short time. We recommend not using this feature more than twice a day."}
        body={[
          <>Using this feature too much makes your account at risk as Linkedin doesn't allow checking too much profiles in a short time.</>,
          <Text textStyle={textStyle["body.medium.light"]}><b>We recommend not using this feature more than twice a day.</b></Text>,
        ]}
        callback={sendRequest}
      />
    </Box>
  );
}
